import React from 'react';

import { SearchkitWrapper } from '@uncinc/react-searchkit';
import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

import {
  DOMAIN_DRUPAL_IDENTIFIER_KVNL,
  SEARCHKIT_HOST_URL,
  SEARCHKIT_INDEX_ALL_CONTENT,
} from '../../config/constants';

import {
  facetAttributes,
  resultAttributes,
} from './config';

type PartnerSearchWrapperProps = Omit<
SearchkitWrapperProps,
'connection' | 'searchSettings' | 'indexName' | 'requestOptions'
>;

const PartnerSearchWrapper: React.FC<PartnerSearchWrapperProps> = (props) => {
  const {
    children,
    ...restProps
  } = props;

  return (
    <SearchkitWrapper
      {...restProps}
      connection={{ host: SEARCHKIT_HOST_URL }}
      indexName={SEARCHKIT_INDEX_ALL_CONTENT}
      searchSettings={{
        search_attributes: ['title'],
        result_attributes: resultAttributes,
        facet_attributes: facetAttributes,
      }}
      requestOptions={{
        // @ts-expect-error A 'must' query is not part of the QueryDslQueryContainer
        // typing, but the query is valid nonetheless. This should be fixed in
        getBaseFilters: () => [
          {
            bool: {
              must: [
                {
                  term: {
                    field_domain_access: {
                      value: DOMAIN_DRUPAL_IDENTIFIER_KVNL,
                    },
                  },
                },
                {
                  term: {
                    type: {
                      value: 'partner',
                    },
                  },
                },
              ],
            },
          },
        ],
      }}
    >
      {children}
    </SearchkitWrapper>
  );
};

export default PartnerSearchWrapper;
